/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const copy_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.69 1H4c-.552 0-1 .444-1 .996v16.626c0 .552.448.993 1 .993h11.143a1 1 0 0 0 1-1V5.654M11.69 1l4.453 4.654M11.69 1v3.655a1 1 0 0 0 1 .999h3.453M21 9.038h-1.429m1.429 0L19.571 7.5M21 9.038V22a1 1 0 0 1-1 1H8.667a.81.81 0 0 1-.74-.5"
    />
  </svg>
)
export default copy_medium
